import Collapse from './collapse';
import CollapseGroup from './collapse-group';
Collapse.Group = CollapseGroup;
export default Collapse;